import React from 'react';
import { PARKING_STATUS_LABELS } from '../../../types/parkingSpace';

interface ParkingStatusFilterProps {
  currentFilter: 'all' | 'occupied' | 'preparing' | 'vacant' | 'contracting';
  onFilterChange: (filter: 'all' | 'occupied' | 'preparing' | 'vacant' | 'contracting') => void;
  spaceCounts: {
    all: number;
    occupied: number;
    preparing: number;
    vacant: number;
    contracting: number;
  };
}

const ParkingStatusFilter: React.FC<ParkingStatusFilterProps> = ({ 
  currentFilter, 
  onFilterChange, 
  spaceCounts 
}) => {
  const filterOptions = [
    { value: 'all' as const, label: '전체', count: spaceCounts.all },
    { value: 'occupied' as const, label: PARKING_STATUS_LABELS.occupied, count: spaceCounts.occupied },
    { value: 'preparing' as const, label: PARKING_STATUS_LABELS.preparing, count: spaceCounts.preparing },
    { value: 'vacant' as const, label: PARKING_STATUS_LABELS.vacant, count: spaceCounts.vacant },
    { value: 'contracting' as const, label: PARKING_STATUS_LABELS.contracting, count: spaceCounts.contracting },
  ];

  const getButtonStyle = (filterValue: string) => {
    const isActive = currentFilter === filterValue;
    const baseStyle = "px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 border";
    
    if (isActive) {
      if (filterValue === 'all') {
        return `${baseStyle} bg-blue-600 text-white border-blue-600`;
      } else if (filterValue === 'occupied') {
        return `${baseStyle} bg-red-600 text-white border-red-600`;
      } else if (filterValue === 'preparing') {
        return `${baseStyle} bg-yellow-600 text-white border-yellow-600`;
      } else if (filterValue === 'vacant') {
        return `${baseStyle} bg-green-600 text-white border-green-600`;
      } else if (filterValue === 'contracting') {
        return `${baseStyle} bg-blue-500 text-white border-blue-500`;
      }
    }
    
    return `${baseStyle} bg-white text-gray-700 border-gray-300 hover:bg-gray-50`;
  };

  return (
    <div className="mb-6">
      <h3 className="text-sm font-medium text-gray-700 mb-3">상태별 필터</h3>
      <div className="flex flex-wrap gap-2">
        {filterOptions.map((option) => (
          <button
            key={option.value}
            onClick={() => onFilterChange(option.value)}
            className={getButtonStyle(option.value)}
          >
            {option.label} ({option.count})
          </button>
        ))}
      </div>
    </div>
  );
};

export default ParkingStatusFilter; 